import { orderConstants, globalConstants } from "../../constants";

const initialState = {
  orderData: {},
  customerData: {},
  productsData: [],
  refundSuccess: false,
  currencyCode: "",
};

const RefundOrder = (state = initialState, action) => {
  switch (action.type) {
    case orderConstants.GET_ORDERS_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        orderData: action.data,
      };
    case orderConstants.CURRENCY_CODE + globalConstants.SUCCESS:
      return {
        ...state,
        currencyCode: action.data,
      };
    case orderConstants.GET_PRODUCTS_BY_ORDERS_ID + globalConstants.SUCCESS:
      return {
        ...state,
        productsData: action.data,
      };
    case orderConstants.GET_CUSTOMER_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        customerData: action.data,
      };
    case orderConstants.REFUND_SUCCESS:
      return {
        ...state,
        refundSuccess: true,
      };

    case orderConstants.RESET_REFUND_SUCCESS:
      return {
        ...state,
        refundSuccess: false,
      };

    default:
      return state;
  }
};

export default RefundOrder;
